// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__ywQsa","check":"CheckBox_check__3zUmM"};